import icons from '@wielink-application/shared/js/mixins/icons.js'
export default icons;